// Selling happens through quotes, so every call to action lands in the same
// place: a WhatsApp chat with the message already written. The phone number
// comes from Rails (config/initializers/casa_lumina.rb) so it is not scattered
// across components.

const GREETING = 'Hola Casa Lumina, quiero'

// wa.me only accepts digits: no +, spaces or dashes.
export function normalizePhone (phone) {
  return String(phone || '').replace(/\D/g, '')
}

// One link per product, so the message arrives with context and nobody has to
// ask "which one of them?".
export function whatsappLink (phone, subject) {
  const digits = normalizePhone(phone)
  const text = subject ? `${GREETING} ${subject}.` : `${GREETING} cortinas a medida.`

  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`
}

// Readable format for on-screen display: +56 9 1234 5678
export function formatPhone (phone) {
  const digits = normalizePhone(phone)
  if (digits.length !== 11 || !digits.startsWith('569')) return `+${digits}`

  return `+56 9 ${digits.slice(3, 7)} ${digits.slice(7)}`
}

// El tracking vive en lib/analytics.js desde que hay dos canales de conversión.
// Se re-exporta acá para que los componentes que ya lo importaban de este
// archivo sigan funcionando.
export { trackConversion } from '@/lib/analytics'
